import Vue from "vue";

import { HEADER_PIN_CHANGED, HEADER_HEIGHT_CHANGED } from "@/store/actions.type";
import { SET_HEADER_PIN, SET_HEADER_HEIGHT } from "@/store/mutations.type";

const state = () => ({
    pinned: true,
    height: 0,
});

const actions = {

    [HEADER_PIN_CHANGED]({ commit }, pinned) {
        commit(SET_HEADER_PIN, pinned);

        return pinned;
    },

    [HEADER_HEIGHT_CHANGED]({ commit }, height) {
        commit(SET_HEADER_HEIGHT, height);

        return height;
    },
};

const mutations = {

    [SET_HEADER_PIN](state, pinned) {
        state.pinned = pinned;
    },

    [SET_HEADER_HEIGHT](state, height) {
        state.height = height;
    },

};

const getters = {

    isPinned: (state) => {
        return state.pinned;
    },

    getHeight: (state) => {
        return state.height;
    }
};


export const header = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
